/* =============================================================
   DUMONDE MEGA MENU ENHANCER
   - Colorează link-urile cu nume de culoare (bulină)
   - Adaugă icon pentru link-uri de dimensiune (140x200 etc)
   - Idempotent: nu rulează de 2x pe același link
   - Observă DOM pentru mega menu lazy-loaded
   ============================================================= */
(function () {
  'use strict';

  // Map culoare → hex (poți edita)
  var COLOR_MAP = {
    'alb': '#ffffff',
    'albă': '#ffffff',
    'alba': '#ffffff',
    'white': '#ffffff',
    'bej': '#e7d7c9',
    'bej deschis': '#f0e4d5',
    'bej închis': '#c9b39a',
    'crem': '#f5f0e1',
    'cream': '#f5f0e1',
    'gri': '#888888',
    'gri deschis': '#c0c0c0',
    'gri închis': '#555555',
    'light grey': '#c0c0c0',
    'dark grey': '#555555',
    'grey': '#888888',
    'grey dark': '#555555',
    'antracit': '#3a3a3a',
    'negru': '#111111',
    'black': '#111111',
    'maro': '#6b4226',
    'brown': '#6b4226',
    'maro închis': '#4a2c17',
    'ciocolată': '#4a2c17',
    'cappuccino': '#a67b5b',
    'roșu': '#b91c1c',
    'red': '#b91c1c',
    'bordo': '#6d1a20',
    'roz': '#f4b6c2',
    'pink': '#f4b6c2',
    'roz pudrat': '#e6c4c8',
    'galben': '#facc15',
    'mustar': '#c79a1e',
    'muștar': '#c79a1e',
    'verde': '#2a6f3f',
    'green': '#2a6f3f',
    'verde oliv': '#6b7a2a',
    'oliv': '#6b7a2a',
    'turcoaz': '#2ca3a8',
    'albastru': '#1e40af',
    'blue': '#1e40af',
    'bleumarin': '#0b1f4a',
    'navy': '#0b1f4a',
    'bleu': '#74a8e0',
    'mov': '#6b21a8',
    'purple': '#6b21a8',
    'auriu': '#b08d57',
    'gold': '#b08d57',
    'argintiu': '#c0c0c0',
    'silver': '#c0c0c0',
    'rose gold': '#c78a7c',
    'lila': '#b99bdc',
    'velur': '#7a4a4a'
  };

  // Icon SVG pat pentru dimensiuni
  var SIZE_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M3 7v11M21 11v7M3 18h18M3 11h18"/>' +
    '<path d="M7 11V8a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v3"/>' +
    '</svg>';

  // Regex pentru dimensiuni: ultra permisiv — orice N x N
  var SIZE_REGEX = /\d+\s*[xX×]\s*\d+/;

  // Debug mode: pune ?dmdebug=1 în URL ca să vezi logs in consolă
  var DEBUG = /[?&]dmdebug=1\b/.test(location.search);
  function dbg() { if (DEBUG && window.console) console.log.apply(console, ['[dumonde-meganav]'].concat([].slice.call(arguments))); }

  // Selectors: toate locurile unde pot apărea link-uri în mega menu
  var LINK_SELECTORS = [
    '.mega-nav a',
    '.main-nav__child a',
    '.main-nav a',
    '.main-nav__item',
    '.main-nav__link',
    'a.child-nav__item',
    '.child-nav a',
    '.child-nav__item a',
    '.grandchild-nav a',
    '.grandchild-nav__link',
    '[data-mega-nav] a',
    'header a',
    '.header__main-nav a',
    '.header-nav a',
    '.js-mega-nav a',
    'nav-menu a'
  ].join(', ');

  function makeColorDot(hex) {
    var dot = document.createElement('span');
    dot.className = 'dm-mega-color-dot';
    dot.setAttribute('aria-hidden', 'true');
    dot.style.cssText =
      'display:inline-block;width:14px;height:14px;border-radius:50%;' +
      'border:1px solid rgba(0,0,0,.18);margin-right:8px;vertical-align:middle;' +
      'flex-shrink:0;background:' + hex + ';' +
      'box-shadow: inset 0 0 0 1px rgba(255,255,255,.35);';
    return dot;
  }

  function makeSizeIcon() {
    var wrap = document.createElement('span');
    wrap.className = 'dm-mega-size-icon';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText =
      'display:inline-flex;align-items:center;justify-content:center;' +
      'width:24px;height:24px;margin-right:10px;vertical-align:middle;' +
      'color:#b08d57;flex-shrink:0;';
    wrap.innerHTML = SIZE_ICON_SVG;
    return wrap;
  }

  function enhanceLink(el) {
    if (!el || el.dataset.dmEnhanced === '1') return;

    // Găsim text-ul vizibil (nu din copii ascunși)
    var raw = (el.textContent || '').trim();
    if (!raw) return;

    // Normalizare: lowercase, fără ghilimele/virgule
    var key = raw.toLowerCase()
      .replace(/["""'`]/g, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/[\u200B-\u200D\uFEFF]/g, '') // zero-width chars
      .trim();

    dbg('check', { text: raw, key: key, href: el.getAttribute && el.getAttribute('href') });

    // 1. COLOR?
    if (COLOR_MAP.hasOwnProperty(key)) {
      if (!el.querySelector('.dm-mega-color-dot')) {
        el.insertBefore(makeColorDot(COLOR_MAP[key]), el.firstChild);
      }
      el.dataset.dmEnhanced = '1';
      dbg('→ color applied', key);
      return;
    }

    // 2. SIZE dimensiune (NNxNN)?
    if (SIZE_REGEX.test(raw)) {
      if (!el.querySelector('.dm-mega-size-icon')) {
        el.insertBefore(makeSizeIcon(), el.firstChild);
      }
      el.dataset.dmEnhanced = '1';
      dbg('→ size applied', raw);
      return;
    }

    // 3. Size "single", "dublu", etc (bonus)
    var SINGLE_SIZE_WORDS = ['single', 'dublu', 'dublu cu somiera', 'king size', 'matrimonial'];
    if (SINGLE_SIZE_WORDS.indexOf(key) !== -1) {
      if (!el.querySelector('.dm-mega-size-icon')) {
        el.insertBefore(makeSizeIcon(), el.firstChild);
      }
      el.dataset.dmEnhanced = '1';
      return;
    }

    // Colecțiile NU mai au thumb — doar culori și dimensiuni rămân
    dbg('→ no visual enhancement for', raw);
  }

  // (loadCollectionThumb eliminat — nu mai vrem poze pentru colecții)

  function cleanupTopLevelThumbs() {
    // 1. Scoate TOATE thumb-urile noastre (nu mai folosim pozele la colecții)
    var allDmThumbs = document.querySelectorAll('.dm-mega-coll-thumb');
    for (var i = 0; i < allDmThumbs.length; i++) {
      allDmThumbs[i].remove();
    }
    // 2. Ascunde TOATE imaginile built-in Enterprise (peste tot — nu vrem poze în nav deloc)
    var builtIn = document.querySelectorAll(
      '.main-nav__collection-image, .child-nav__collection-image'
    );
    for (var j = 0; j < builtIn.length; j++) {
      builtIn[j].style.display = 'none';
    }
  }

  function scan(root) {
    root = root || document;
    var links = root.querySelectorAll(LINK_SELECTORS);
    for (var i = 0; i < links.length; i++) {
      enhanceLink(links[i]);
    }
    cleanupTopLevelThumbs();
  }

  // Run once când DOM gata
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Observer pentru conținut adăugat lazy (hover / route change)
  if (typeof MutationObserver !== 'undefined') {
    var obs = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1) {
            if (n.matches && n.matches(LINK_SELECTORS)) enhanceLink(n);
            scan(n);
          }
        }
      }
    });
    obs.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // Expune pentru debugging manual (în consolă: window.dumondeMegaNavRescan())
  window.dumondeMegaNavRescan = function () { scan(); };
})();
